import styled from 'styled-components'
import { Button } from '@mui/material'
import LoadingSpinner from 'components/ui/LoadingSpinner'

interface Props {
  status: RequestStatus
  text: JSX.Element | string
  id?: string
  className?: string
  disabled?: boolean
  fullWidth?: boolean
  testId?: string
  handleSubmit?: () => void
}

export default function SubmitButton({
  status,
  text,
  id,
  className,
  disabled,
  fullWidth,
  testId,
  handleSubmit,
}: Props): JSX.Element {
  const elementId = id || Math.random().toString(36).substring(7)
  return (
    <ButtonElement
      type={handleSubmit ? 'button' : 'submit'}
      color="primary"
      variant="contained"
      disabled={status === 'loading' || disabled}
      id={elementId}
      className={className}
      fullWidth={fullWidth}
      onClick={handleSubmit}
      data-testid={testId}
    >
      {status === 'loading' ? <LoadingSpinner size={24} /> : text}
    </ButtonElement>
  )
}

const ButtonElement = styled(Button)`
  &.Mui-disabled {
    background-color: ${(props) => props.theme.palette.primary.main};
    color: ${(props) => props.theme.customPalette.light};
    opacity: 0.5;
  }
  text-transform: none;
`
